export const statusColors = {
  'Yeni': 'bg-blue-100 text-blue-800',
  'Baxılır': 'bg-yellow-100 text-yellow-800',
  'Tamamlandı': 'bg-green-100 text-green-800',
  'Ləğv edildi': 'bg-red-100 text-red-800'
};

export const STATUS_OPTIONS = ['Yeni', 'Baxılır', 'Tamamlandı', 'Ləğv edildi'];
export const PRODUCT_OPTIONS = ['İstehlak Krediti', 'Qızıl Krediti', 'Avto Lizinq', 'Ümumi sual'];

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString('az-AZ', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};
